import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-sm-12" }
const _hoisted_6 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_7 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_8 = {
  key: 0,
  class: "nav-item nav-item-spaced d-lg-block text-nowrap"
}
const _hoisted_9 = {
  key: 0,
  class: "row m-4 mt-0 mb-0"
}
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "card card-body mb-0" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_19 = { class: "col p-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_22 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_23 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_30 = { class: "col p-0" }
const _hoisted_31 = { class: "form-check small mb-0 mt-1" }
const _hoisted_32 = {
  class: "form-check-label",
  for: "onlyActiveRequisites"
}
const _hoisted_33 = { class: "form-check small mb-0" }
const _hoisted_34 = {
  class: "form-check-label",
  for: "onlyActiveTraders"
}
const _hoisted_35 = { class: "form-group mb-2 col" }
const _hoisted_36 = { class: "col-auto p-0 text-end" }
const _hoisted_37 = {
  key: 1,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_38 = { class: "col-sm-12" }
const _hoisted_39 = { class: "card card-body mb-0" }
const _hoisted_40 = { class: "overflow-auto" }
const _hoisted_41 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_42 = { class: "bg-light" }
const _hoisted_43 = { class: "text-capitalize-first" }
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = { class: "text-capitalize-first" }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { class: "text-capitalize-first" }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { class: "text-capitalize-first" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }
const _hoisted_52 = { class: "text-capitalize-first" }
const _hoisted_53 = {
  key: 2,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_54 = { class: "col-sm-12" }
const _hoisted_55 = { class: "card card-body mb-0" }
const _hoisted_56 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_57 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_58 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_59 = { class: "bg-light" }
const _hoisted_60 = { class: "text-capitalize-first" }
const _hoisted_61 = { class: "text-capitalize-first" }
const _hoisted_62 = { class: "text-capitalize-first" }
const _hoisted_63 = { class: "text-capitalize-first" }
const _hoisted_64 = { class: "text-capitalize-first" }
const _hoisted_65 = {
  key: 2,
  class: "text-center text-muted py-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectTab(_ctx.Tabs.list)), ["prevent"])),
                      class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === _ctx.Tabs.list}])
                    }, _toDisplayString(_ctx.helper.trans('statistic.requisites.tab.list')), 3)
                  ]),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectTab(_ctx.Tabs.capacity)), ["prevent"])),
                          class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === _ctx.Tabs.capacity}])
                        }, _toDisplayString(_ctx.helper.trans('statistic.requisites.tab.capacity')), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.activeTabName === _ctx.Tabs.list)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_TraderMultiselect, {
                              multiple: true,
                              modelValue: _ctx.tradersFilter,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tradersFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_Multiselect, {
                              id: "methods",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.methods,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                              options: _ctx.store.getters['currencyMethods/methods'](),
                              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.payment_methods')
                            }, {
                              option: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_PayMethodIcon, {
                                    "icon-class": "icon",
                                    method: props.option
                                  }, null, 8, ["method"]),
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_Multiselect, {
                              id: "options",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.options,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                              options: _ctx.store.getters['currencyMethods/options'](),
                              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.payment_options')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_Multiselect, {
                              id: "currency",
                              class: "multiselect-sm multiselect-capitalize",
                              modelValue: _ctx.requestDTO.currency,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.currency) = $event)),
                              options: _ctx.store.getters['currencyMethods/currencies'],
                              "custom-label": (opt) => opt,
                              multiple: false,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.currency')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.onlyActiveRequisites) = $event)),
                              type: "checkbox",
                              id: "onlyActiveRequisites"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.requestDTO.onlyActiveRequisites]
                            ]),
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.only_active_requisites')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.onlyActiveTraders) = $event)),
                              type: "checkbox",
                              id: "onlyActiveTraders"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.requestDTO.onlyActiveTraders]
                            ]),
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.only_active_traders')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                            class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                            class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTabName === _ctx.Tabs.list)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("table", _hoisted_41, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_42, [
                        _createElementVNode("th", _hoisted_43, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.payment_method')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'paymentmethod'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'paymentmethod')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_44, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.payment_option')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'paymentoption'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'paymentoption')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_45, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.total')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'total'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'total')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_46, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.traderActive')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'traderactive'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'traderactive')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_47, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.deviceOnline')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'deviceonline'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'deviceonline')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_48, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.deviceNotBlocked')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'devicenotblocked'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'devicenotblocked')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_49, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.min1000')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'min1000'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'min1000')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_50, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.min3000')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'min3000'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'min3000')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_51, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.min5000')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'min5000'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'min5000')])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_52, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.requisites_summary.inUse')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'inuse'); }, ["prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'inuse')])
                            }, null, 2)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, (item) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`pay_methods.${item.paymentmethod}`)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`payment_options.${item.paymentoption}`)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.total)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.traderactive)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.deviceonline)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.devicenotblocked)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.min1000)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.min3000)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.min5000)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.inuse)), 1)
                        ]))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTabName === _ctx.Tabs.capacity && _ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                (!_ctx.capacityData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.helper.trans('requisites_capacity.loading')), 1))
                  : (_ctx.capacityData && _ctx.capacityData.rows && _ctx.capacityData.rows.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("table", _hoisted_58, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_59, [
                              _createElementVNode("th", _hoisted_60, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites_capacity.currency')) + " ", 1),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.capacityOrderByDTO, 'currency'); }, ["prevent"]))
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.capacityOrderByDTO, 'currency')])
                                  }, null, 2)
                                ])
                              ]),
                              _createElementVNode("th", _hoisted_61, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.payment_option')) + " ", 1),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.capacityOrderByDTO, 'paymentOption'); }, ["prevent"]))
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.capacityOrderByDTO, 'paymentOption')])
                                  }, null, 2)
                                ])
                              ]),
                              _createElementVNode("th", _hoisted_62, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites_capacity.min_check')) + " ", 1),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.capacityOrderByDTO, 'minCheck'); }, ["prevent"]))
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.capacityOrderByDTO, 'minCheck')])
                                  }, null, 2)
                                ])
                              ]),
                              _createElementVNode("th", _hoisted_63, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites_capacity.requisites_count')) + " ", 1),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.capacityOrderByDTO, 'requisitesCount'); }, ["prevent"]))
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.capacityOrderByDTO, 'requisitesCount')])
                                  }, null, 2)
                                ])
                              ]),
                              _createElementVNode("th", _hoisted_64, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites_capacity.liquidity')) + " ", 1),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.capacityOrderByDTO, 'liquidity'); }, ["prevent"]))
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.capacityOrderByDTO, 'liquidity')])
                                  }, null, 2)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCapacityItems, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(item.currency), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`payment_options.${item.paymentOption}`)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.minCheck)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.requisitesCount)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({'text-danger': item.liquidity < 0})
                                  }, _toDisplayString(_ctx.numberFormatter.formatNumber(item.liquidity)), 3)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : (_ctx.capacityData !== null && (!_ctx.capacityData.rows || _ctx.capacityData.rows.length === 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.helper.trans('requisites_capacity.no_data')), 1))
                      : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}